import { render } from "./PlayerReproduction.vue?vue&type=template&id=6c40997f&scoped=true"
import script from "./PlayerReproduction.vue?vue&type=script&lang=js"
export * from "./PlayerReproduction.vue?vue&type=script&lang=js"

import "./PlayerReproduction.vue?vue&type=style&index=0&id=6c40997f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c40997f"]])

export default __exports__